import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Tag } from '../webApi/DataModels'
import { map, filter } from 'lodash'
import constants from '@/constants'

class TagState {
  public tags: Tag[] = []
  public tagOptions: any[] = []
}

const mutations = <MutationTree<TagState>>{
  setTags (state: TagState, tags: Tag[]) {
    state.tags = tags
    state.tagOptions = tags.map((tag: Tag) => {
      return {
        value: tag.Tag_ID,
        label: tag.Tag_Name,
        selected: false
      }
    })
    window.sessionStorage.setItem('Tag_List', JSON.stringify(state.tags))
  },
  reset (state:TagState) {
    state.tags = []
    state.tagOptions = []
  }
}

const actions = <ActionTree<TagState, any>>{
  reset (store: ActionContext<TagState, any>):void {
    store.commit('reset')
  },
  loadTags (store: ActionContext<TagState, any>):Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.TAG, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
      .then((hasPermission): any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          if (window.sessionStorage.getItem('Tag_List') != null) {
          // the list has already been stored in session
            store.commit('setTags', JSON.parse(window.sessionStorage.getItem('Tag_List')))
            return Promise.resolve('success')
          } else {
          // the list has not been stored in session yet, load from server
            return webApi.tag.get_Tags().then(
              (response) => {
              // Store the response
                store.commit('setTags', response.data)
                return Promise.resolve('success')
              }).catch((response) => {
              window.bus.$emit('openErrorModal', 'error loading tags: ' + response.ExceptionMessage)
              return Promise.reject(response)
            })
          }
        }
      })
  }
}

const getters = <GetterTree<TagState, any>>{
  tags: (state) => {
    return state.tags
  },
  tagOptions: (state) => {
    return state.tagOptions
  },
  tagNames (state:TagState):any {
    return (tagIDs:number[]) => {
      return map(filter(state.tags, tag => (tagIDs.indexOf(tag.Tag_ID) > -1)), 'Tag_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new TagState(),
  mutations,
  actions,
  getters
})
